import { Box } from '@mui/material'
import { FC, ReactNode } from 'react'
import Linkify from 'react-linkify'

type LinkifyBoxProps = {
  children: ReactNode
}

export const LinkifyBox: FC<LinkifyBoxProps> = ({ children }) => {
  return (
    <Box
      sx={{
        '.linkify': {
          color: 'primary.main',
          textDecoration: 'none',
        },
      }}
    >
      <Linkify
        componentDecorator={(decoratedHref, decoratedText, key) => (
          <a
            target="_blank"
            style={{ textDecoration: 'none' }}
            href={decoratedHref}
            key={key}
            className="linkify"
          >
            {decoratedText}
          </a>
        )}
      >
        {children}
      </Linkify>
    </Box>
  )
}
